import { Attribute } from "../Types/Attribute";

interface FetchAttributePayload {
    elementGuid: string;
    attributeGuid: string;
    hoursStarting: number;
}

var GuidAttributePairs: { [elementGuid: string]: [attribute: string]; } = {};


export async function fetchAttribute(payload: FetchAttributePayload) {
    let url = "";
    const apiUrl = process.env.REACT_APP_API_URL;
    if (payload.hoursStarting === 0) {
        url = `${apiUrl}/teams/attributes/?eguid=${payload.elementGuid}&aguid=${payload.attributeGuid}`;
    } else {
        url = `${apiUrl}/teams/attributes/?eguid=${payload.elementGuid}&aguid=${payload.attributeGuid}&hoursstarting=${payload.hoursStarting}`;
    }

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "lksfj"
            }
        });
        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        } else {
            return Promise.reject("Failed to fetch attributes");
        }
    } catch (error) {
        console.error("Failed to fetch data", error);
        return;
    }
}

export async function fetchAttributes(payload: { [elementGuid: string]: string }) {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/attributes`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
        });

        console.log(JSON.stringify(payload));
        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
}

export async function fetchAttributesPdp2(payload: { [elementGuid: string]: string }) {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/attributes/pdp2`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
}